import type { TFunction } from 'i18next';
import { REPORTING_CODES } from '@eis/core/reporting';

/**
 * The refusal codes the console holds messages for (SDD-024 §6.3, plus the SDD-017 list codes): the
 * service's `svccontract` set and this list must agree — `codes-parity.test.ts` fails when a code
 * exists on one side only. Messages live under `reporting:codes.<CODE>.{title,hint}`.
 */
export const CONSOLE_CODES: readonly string[] = REPORTING_CODES;

export interface CodeMessage {
  readonly title: string;
  readonly hint: string;
}

export function codeMessage(t: TFunction<'reporting'>, code: string | undefined): CodeMessage {
  if (code === undefined || !CONSOLE_CODES.includes(code)) {
    return { title: t('codes.QUERY_FAILED.title'), hint: t('codes.QUERY_FAILED.hint') };
  }
  return {
    title: t(`codes.${code}.title` as never),
    hint: t(`codes.${code}.hint` as never),
  };
}
